module.exports = __webpack_public_path__ + "static/media/upArrow.8b7cef43.svg";